<div class="document-page-container">
  <div class="mobile-section-switcher" *ngIf="isTab || isMobile">
    <div
      class="section-tab"
      [class.active]="activeMobileSection === 'redactor'"
      (click)="switchMobileSection('redactor')"
    >
      Editor
    </div>
    <div
      class="section-tab"
      [class.active]="activeMobileSection === 'pdf'"
      (click)="switchMobileSection('pdf')"
    >
      Preview
    </div>
  </div>

  <div
    class="document-page-title"
    [style]="editing && isMobile ? 'flex-direction: column;' : ''"
  >
    <div class="document-page-title-title">
      <img src="https://s3.ru1.storage.beget.cloud/b46325dbaad6-ilove/voucher-templates/images/logo-oval.png" alt="logo">
      {{ title }}
    </div>
    <div
      class="document-page-title-buttons"
      [style]="editing && isMobile ? 'margin-top: 1rem;' : ''"
    >
      <span
        class="document-page-title-button document-page-title-button-red"
        (click)="confirmDelete(this.document.id)"
        *ngIf="this.route.snapshot.paramMap.get('id') !== 'add' && !editing"
      >
        delete
      </span>
      <span
        *ngIf="editing"
        class="document-page-title-button document-page-title-button-black"
        (click)="addSection('Hotel')"
        [style]="editing && isMobile ? 'font-size: 9px;' : ''"
      >
        <span *ngIf="!isMobile">+</span> Hotel
      </span>
      <span
        *ngIf="editing"
        class="document-page-title-button document-page-title-button-black"
        (click)="addSection('Departure')"
        [style]="editing && isMobile ? 'font-size: 9px;' : ''"
      >
        <span *ngIf="!isMobile">+</span> Departure
      </span>
      <span
        *ngIf="editing"
        class="document-page-title-button document-page-title-button-black"
        (click)="addSection('Transit')"
        [style]="editing && isMobile ? 'font-size: 9px;' : ''"
      >
        <span *ngIf="!isMobile">+</span> Transit
      </span>
      <span
        *ngIf="editing"
        class="document-page-title-button document-page-title-button-black"
        (click)="addSection('Arrival')"
        [style]="editing && isMobile ? 'font-size: 9px;' : ''"
      >
        <span *ngIf="!isMobile">+</span> Arrival
      </span>
      <span
        *ngIf="editing"
        class="document-page-title-button document-page-title-button-black"
        (click)="addSection('Transfer')"
        [style]="editing && isMobile ? 'font-size: 9px;' : ''"
      >
        <span *ngIf="!isMobile">+</span> Transfer
      </span>
      <span *ngIf="!editing" class="document-page-title-button document-page-title-button-black" (click)="downloadFile()">download</span>
      <span *ngIf="!editing" class="document-page-title-button document-page-title-button-black" (click)="edit()">edit</span>
      <span
        *ngIf="editing"
        class="document-page-title-button document-page-title-button-green"
        (click)="onSubmit()"
        [style]="editing && isMobile ? 'font-size: 9px;' : ''"
      >
        save
      </span>
      <span
        *ngIf="editing"
        class="document-page-title-button document-page-title-button-blue"
        (click)="cancel()"
        [style]="editing && isMobile ? 'font-size: 9px;' : ''"
      >
        cancel
      </span>
      <span *ngIf="!editing" class="document-page-title-button document-page-title-button-black" [routerLink]="'/documents'">back</span>
    </div>
  </div>
  <div class="document-page-workspace">
    <div
      class="document-page-workspace-case"
      *ngIf="showSections('redactor')"
      [class.mobile-active]="activeMobileSection === 'redactor'"
      #scrollContainer
    >
      <form [formGroup]="myForm" (ngSubmit)="onSubmit()" (click)="showEditModeRequiredModal()" [style]="!editing ? 'cursor: not-allowed;': ''">
        <div class="field">
          <div class="field-text">
            <label for="id">id</label>
            <input id="id" name="id" formControlName="id" type="text" [disabled]="!editing" [class.disabled]="!editing"/>
          </div>
        </div>
        <div class="field" [class]="!editing ? 'field-disable' : ''">
          <div class="field-text">
            <label for="type">Type</label>
            <select #type
                    (change)="setType(type.value)"
                    [(ngModel)]="documentType" [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    [class.disabled]="!editing"
            >
              <option value="">--Unselect--</option>
              <option *ngFor="let item of documentTypes" [value]="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>
        <div class="field" [class]="!editing ? 'field-disable' : ''">
          <div class="field-text">
            <label for="documentDate">Document Date</label>
            <input id="documentDate" name="documentDate" formControlName="documentDate" type="date" [readOnly]="!editing" [class.disabled]="!editing"/>
          </div>
        </div>
        <div class="field field-full-width" (click)="openArray($event)">
          <label class="to-relative">
            <span *ngIf="checkLength('Hotels')">Hotels ({{ getCountByType('Hotels') }})</span>
            <span *ngIf="checkLength('Departures')">Departures ({{ getCountByType('Departures') }})</span>
            <span *ngIf="checkLength('Transits')">Transits ({{ getCountByType('Transits') }})</span>
            <span *ngIf="checkLength('Arrivals')">Arrivals ({{ getCountByType('Arrivals') }})</span>
            <span *ngIf="checkLength('Transfers')">Transfers ({{ getCountByType('Transfers') }})</span>
<!--            <div class="arrow-icon">-->
<!--              <app-icon-->
<!--                [icon]="Icons.formArrow"-->
<!--                [class.rotated]="openArrays"-->
<!--                style="cursor: pointer; z-index: 800"-->
<!--              />-->
<!--            </div>-->
          </label>
          <div
            class="field-array"
            [style]="editing ? '' : 'cursor: not-allowed;'"
            (click)="$event.stopPropagation(); showEditModeRequiredModal()"
            @slideInOut
            @staggerSlide
          >
            <div class="field-array-item" style="margin-top: 1rem" *ngIf="sectionArrays.length === 0">
              No entries yet
            </div>
            <div
              class="field-array-item"
              [class]="!editing ? 'field-array-item-disable' : ''"
              [class.deleting]="item._deleting"
              *ngFor="let item of sectionArrays; index as i; trackBy: trackByFn"
              @itemAdd
              @itemRemove
            >
              <div class="field-array-item-close" *ngIf="editing">
                <app-icon [icon]="Icons.thinClose" (click)="deleteSection(i)"/>
              </div>
              <div class="field-array-item-rotate"
                   style="rotate: 180deg;"
                   *ngIf="editing && !isFirstSection(i)"
                   [style.right.px]="isLastSection(i) ? 26 : 46">
                <app-icon [icon]="Icons.formArrow" (click)="rotateSection('up', i)"/>
              </div>
              <div
                class="field-array-item-rotate"
                style="right: 26px"
                *ngIf="editing && !isLastSection(i)">
                <app-icon [icon]="Icons.formArrow" (click)="rotateSection('down', i)"/>
              </div>
              <div *ngIf="item.type === 'Hotel'" class="section-content">
                <div class="field-array-item-label">
                  Hotel
                </div>
                <div class="field-array-item-field">
                  <label for="address">Guest Names</label>
                  <textarea
                    [(ngModel)]="item.guestNames"
                    [ngModelOptions]="{standalone: true}"
                    [readOnly]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Hotel Name</label>
                  <textarea
                    [(ngModel)]="item.hotelName"
                    [ngModelOptions]="{standalone: true}"
                    [readOnly]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Accommodation</label>
                  <textarea
                    [(ngModel)]="item.accommodation"
                    [ngModelOptions]="{standalone: true}"
                    [readOnly]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Meal Plan</label>
                  <textarea
                    [(ngModel)]="item.mealPlan"
                    [ngModelOptions]="{standalone: true}"
                    [readOnly]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Stay Period Begin</label>
                  <input
                    [(ngModel)]="item.stayPeriodBegin"
                    [ngModelOptions]="{standalone: true}" type="date"
                    [readOnly]="!editing"
                    [class.disabled]="!editing"
                  />
                </div>
                <div class="field-array-item-field">
                  <label for="address">Stay Period End</label>
                  <input
                    [(ngModel)]="item.stayPeriodEnd"
                    [ngModelOptions]="{standalone: true}" type="date"
                    [readOnly]="!editing"
                    [class.disabled]="!editing"
                  />
                </div>
                <div class="field-array-item-field" *ngIf="documentType != 'OFFER'">
                  <label for="address">Check In Time</label>
                  <input
                    [(ngModel)]="item.checkInTime"
                    [ngModelOptions]="{standalone: true}" type="time"
                    [readOnly]="!editing"
                    [class.disabled]="!editing"
                  />
                </div>
                <div class="field-array-item-field" *ngIf="documentType != 'OFFER'">
                  <label for="address">Check Out Time</label>
                  <input
                    [(ngModel)]="item.checkOutTime"
                    [ngModelOptions]="{standalone: true}" type="time"
                    [readOnly]="!editing"
                    [class.disabled]="!editing"
                  />
                </div>
                <div class="field-array-item-field" *ngIf="documentType != 'OFFER'">
                  <label for="address">hotel Address</label>
                  <textarea
                    [(ngModel)]="item.hotelAddress"
                    [ngModelOptions]="{standalone: true}"
                    [readOnly]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field" *ngIf="documentType != 'OFFER'">
                  <label for="address">Hotel Confirmation Number</label>
                  <textarea
                    [(ngModel)]="item.hotelConfirmationNumber"
                    [ngModelOptions]="{standalone: true}"
                    [readOnly]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Additional Services</label>
                  <textarea
                    [(ngModel)]="item.additionalServices"
                    [ngModelOptions]="{standalone: true}"
                    [readOnly]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Remarks</label>
                  <textarea
                    [(ngModel)]="item.remarks"
                    [ngModelOptions]="{standalone: true}"
                    [readOnly]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field" *ngIf="documentType == 'OFFER'">
                  <label for="address">Link</label>
                  <textarea
                    [(ngModel)]="item.link"
                    [ngModelOptions]="{standalone: true}"
                    [readOnly]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field" *ngIf="documentType == 'OFFER'">
                  <label for="address">Cancellation Policy</label>
                  <textarea
                    [(ngModel)]="item.cancellationPolicy"
                    [ngModelOptions]="{standalone: true}"
                    [readOnly]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field-container" *ngIf="documentType == 'OFFER'">
                  <div class="field-array-item-price">
                    <div class="field-array-item-price-item">
                      <label for="address">Price</label>
                      <input
                        [(ngModel)]="item.price"
                        [ngModelOptions]="{standalone: true}" type="number"
                        [readOnly]="!editing"
                        [class.disabled]="!editing"
                      />
                    </div>
                    <div class="field-array-item-price-item">
                      <label for="type">Currency</label>
                      <select
                        [(ngModel)]="item.currency"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!editing"
                        [class.disabled]="!editing"
                      >
                        <option value="">--Unselect--</option>
                        <option *ngFor="let currency of currencies" [value]="currency.symbol">
                          {{ currency.code + ' ' + currency.symbol }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="item.type === 'Departure'" class="section-content">
                <div class="field-array-item-label">
                  Departure
                </div>
                <div class="field-array-item-field">
                  <label for="address">Flight Date Time</label>
                  <input
                    [ngModel]="formatDateForInput(item.flightDateTime)"
                    (ngModelChange)="item.flightDateTime = formatDateForBackend($event)"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    type="datetime-local"
                    [class.disabled]="!editing"
                  />
                </div>
                <div class="field-array-item-field">
                  <label for="address">Flight Number</label>
                  <textarea
                    [(ngModel)]="item.flightNumber"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Airport Name</label>
                  <textarea
                    [(ngModel)]="item.airportName"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Guests</label>
                  <textarea
                    [(ngModel)]="item.guests"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Service Name</label>
                  <textarea
                    [(ngModel)]="item.serviceName"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Additional Services</label>
                  <textarea
                    [(ngModel)]="item.additionalServices"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Remarks</label>
                  <textarea
                    [(ngModel)]="item.remarks"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field-container" *ngIf="documentType == 'OFFER'">
                  <div class="field-array-item-price">
                    <div class="field-array-item-price-item">
                      <label for="address">Price</label>
                      <input
                        [(ngModel)]="item.price"
                        [ngModelOptions]="{standalone: true}" type="number"
                        [readOnly]="!editing"
                        [class.disabled]="!editing"
                      />
                    </div>
                    <div class="field-array-item-price-item">
                      <label for="type">Currency</label>
                      <select
                        [(ngModel)]="item.currency"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!editing"
                        [class.disabled]="!editing"
                      >
                        <option value="">--Unselect--</option>
                        <option *ngFor="let currency of currencies" [value]="currency.symbol">
                          {{ currency.code + ' ' + currency.symbol }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="item.type === 'Transit'" class="section-content">
                <div class="field-array-item-label">
                  Transit
                </div>
                <div class="field-array-item-field">
                  <label for="address">Flight Date Time</label>
                  <input
                    [ngModel]="formatDateForInput(item.flightDateTime)"
                    (ngModelChange)="item.flightDateTime = formatDateForBackend($event)"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    type="datetime-local"
                    [class.disabled]="!editing"
                  />
                </div>
                <div class="field-array-item-field">
                  <label for="address">Flight Number</label>
                  <textarea
                    [(ngModel)]="item.flightNumber"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Airport Name</label>
                  <textarea
                    [(ngModel)]="item.airportName"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Guests</label>
                  <textarea
                    [(ngModel)]="item.guests"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Service Name</label>
                  <textarea
                    [(ngModel)]="item.serviceName"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Additional Services</label>
                  <textarea
                    [(ngModel)]="item.additionalServices"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Remarks</label>
                  <textarea
                    [(ngModel)]="item.remarks"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field-container" *ngIf="documentType == 'OFFER'">
                  <div class="field-array-item-price">
                    <div class="field-array-item-price-item">
                      <label for="address">Price</label>
                      <input
                        [(ngModel)]="item.price"
                        [ngModelOptions]="{standalone: true}" type="number"
                        [readOnly]="!editing"
                        [class.disabled]="!editing"
                      />
                    </div>
                    <div class="field-array-item-price-item">
                      <label for="type">Currency</label>
                      <select
                        [(ngModel)]="item.currency"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!editing"
                        [class.disabled]="!editing"
                      >
                        <option value="">--Unselect--</option>
                        <option *ngFor="let currency of currencies" [value]="currency.symbol">
                          {{ currency.code + ' ' + currency.symbol }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="item.type === 'Arrival'" class="section-content">
                <div class="field-array-item-label">
                  Arrival
                </div>
                <div class="field-array-item-field">
                  <label for="address">Flight Date Time</label>
                  <input
                    [ngModel]="formatDateForInput(item.flightDateTime)"
                    (ngModelChange)="item.flightDateTime = formatDateForBackend($event)"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    type="datetime-local"
                    [class.disabled]="!editing"
                  />
                </div>
                <div class="field-array-item-field">
                  <label for="address">Flight Number</label>
                  <textarea
                    [(ngModel)]="item.flightNumber"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Airport Name</label>
                  <textarea
                    [(ngModel)]="item.airportName"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Guests</label>
                  <textarea
                    [(ngModel)]="item.guests"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Service Name</label>
                  <textarea
                    [(ngModel)]="item.serviceName"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Additional Services</label>
                  <textarea
                    [(ngModel)]="item.additionalServices"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Remarks</label>
                  <textarea
                    [(ngModel)]="item.remarks"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field-container" *ngIf="documentType == 'OFFER'">
                  <div class="field-array-item-price">
                    <div class="field-array-item-price-item">
                      <label for="address">Price</label>
                      <input
                        [(ngModel)]="item.price"
                        [ngModelOptions]="{standalone: true}" type="number"
                        [readOnly]="!editing"
                        [class.disabled]="!editing"
                      />
                    </div>
                    <div class="field-array-item-price-item">
                      <label for="type">Currency</label>
                      <select
                        [(ngModel)]="item.currency"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!editing"
                        [class.disabled]="!editing"
                      >
                        <option value="">--Unselect--</option>
                        <option *ngFor="let currency of currencies" [value]="currency.symbol">
                          {{ currency.code + ' ' + currency.symbol }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="item.type === 'Transfer'" class="section-content">
                <div class="field-array-item-label">
                  Transfer
                </div>
                <div class="field-array-item-field">
                  <label for="address">Pick Up</label>
                  <input
                    [ngModel]="formatDateForInput(item.pickUp)"
                    (ngModelChange)="item.pickUp = formatDateForBackend($event)"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    type="datetime-local"
                    [class.disabled]="!editing"
                  />
                </div>
                <div class="field-array-item-field">
                  <label for="address">Car And Route</label>
                  <textarea
                    [(ngModel)]="item.carAndRoute"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Additional Services</label>
                  <textarea
                    [(ngModel)]="item.additionalServices"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field">
                  <label for="address">Remarks</label>
                  <textarea
                    [(ngModel)]="item.remarks"
                    [ngModelOptions]="{standalone: true}"
                    [disabled]="!editing"
                    (input)="autoResizeTextarea($event)"
                    (keydown)="onTextareaKeydown($event)"
                    class="auto-resize-textarea"
                    rows="1"
                    [class.disabled]="!editing">
                  </textarea>
                </div>
                <div class="field-array-item-field-container" *ngIf="documentType == 'OFFER'">
                  <div class="field-array-item-price">
                    <div class="field-array-item-price-item">
                      <label for="address">Price</label>
                      <input
                        [(ngModel)]="item.price"
                        [ngModelOptions]="{standalone: true}" type="number"
                        [readOnly]="!editing"
                        [class.disabled]="!editing"
                      />
                    </div>
                    <div class="field-array-item-price-item">
                      <label for="type">Currency</label>
                      <select
                        [(ngModel)]="item.currency"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="!editing"
                        [class.disabled]="!editing"
                      >
                        <option value="">--Unselect--</option>
                        <option *ngFor="let currency of currencies" [value]="currency.symbol">
                          {{ currency.code + ' ' + currency.symbol }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div
      class="document-page-workspace-case"
      *ngIf="showSections('pdf')"
      [class.mobile-active]="activeMobileSection === 'pdf'"
    >
      <app-pdf-viewer [pdfUrl]="pdfUrl"/>
    </div>
  </div>
</div>

<div class="modal-overlay" *ngIf="showDeleteModal" (click)="cancelDelete()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Confirm Deletion</h3>
      <div class="modal-close" (click)="cancelDelete()">
        <app-icon [icon]="Icons.thinClose" />
      </div>
    </div>

    <div class="modal-content">
      <p>Are you sure you want to delete this document?</p>
      <p class="modal-warning">This action cannot be undone.</p>
    </div>

    <div class="modal-actions">
      <button class="modal-button modal-button-delete" (click)="executeDelete()">
        Confirm
      </button>
      <button class="modal-button modal-button-cancel" (click)="cancelDelete()">
        Cancel
      </button>
    </div>
  </div>
</div>
<div class="modal-overlay" *ngIf="showEditModeModal" (click)="closeEditModeModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Edit Mode Required</h3>
      <div class="modal-close" (click)="closeEditModeModal()">
        <app-icon [icon]="Icons.thinClose" />
      </div>
    </div>

    <div class="modal-content">
      <p>Please enable edit mode to modify this field.</p>
    </div>

    <div class="modal-actions">
      <button class="modal-button modal-button-primary" (click)="closeEditModeModal()">
        OK
      </button>
    </div>
  </div>
</div>
<div class="loading-container" *ngIf="loading">
  <app-loading/>
</div>
